import { createSlice } from "@reduxjs/toolkit";

const counterSlice = createSlice({
    name:"counters",
    initialState:{
        counters:null
    },
    reducers:{
        setCounterList(state,action){
            state.counters = action?.payload;
        },
    }
})


export const {setCounterList} = counterSlice.actions
export default counterSlice.reducer